import * as constActions from './scannerPageConstActions';
import Api from '../api/scannerApi';
import { isNewBackend } from 'config';

export function StopScanner() {
  return function (dispatch) {
    return Api.stopScanner()
      .then(result => {
        dispatch(GetScannerStatusSuccess(result.is_scan_active));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function StartScanner() {
  return function (dispatch) {
    return Api.startScanner()
      .then(result => {
        dispatch(GetScannerStatusSuccess(result.is_scan_active));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function RestartScanner() {
  return function (dispatch) {
    return Api.restartScans()
      .then(result => {
        dispatch(GetScannerStatusSuccess(result.is_scan_active));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchSearchScanner(entity, parameters, start, end, orderByDetails) {
  return function (dispatch) {
    return Api.fetchScannerData(entity, parameters, start, end, orderByDetails)
      .then(results => {
        if (start == 0) {
          dispatch(fetchSearchScannerSuccess(results));
        } else {
          dispatch(fetchExistingSearchScannerSuccess(results));
        }
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchSearchScannerSuccess(results) {
  return {
    type: constActions.FETCH_SCANNER_RESULTS,
    results
  };
}
export function fetchExistingSearchScannerSuccess(results) {
  return {
    type: constActions.FETCH_SCANNER_EXISTING_RESULTS,
    results
  };
}

export function initFetchScannerData() {
  return function (dispatch) {
    return Api.initScannerData()
      .then(results => {
        dispatch(initFetchScannerDataSuccess(results));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function initFetchScannerDataSuccess(results) {
  return {
    type: constActions.INIT_SCANNER_DATA,
    results
  };
}

export function getScannerHeaderColumns() {
  return function (dispatch) {
    let results = Api.getScannerHeaderColumns();
    dispatch(getScannerHeaderColumnsSuccess(results));
  };
}

export function getScannerHeaderColumnsSuccess(headers) {
  return {
    type: constActions.GET_SCANNER_HEADER_COLUMNS,
    headers
  };
}

export function getScannerColumns() {
  return function (dispatch) {
    return Api.getScannerColumns()
      .then(columns => {
        dispatch(getScannerColumnsSuccess(columns));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function resetScanStatsList() {
  return (dispatch, getState) => {
    let columns = getState().scannerPage.allColumns;
    if (columns.length > 0) {
      let updatedColumns = columns.map(col => {
        let newCol = Object.assign({}, col);
        if (newCol.field_id == 5) {
          newCol.enum_objects = [];
        }
        return newCol;
      });
      dispatch(getScannerColumnsSuccess(updatedColumns));
    }
  };
}

export function getScannerColumnsSuccess(columns) {
  return {
    type: constActions.GET_SCANNER_COLUMNS,
    columns
  };
}
export function getNumberOfScannedHostsSince() {
  return function (dispatch) {
    return Api.GetNumberOfScannedHostsSince().then(results => {
      dispatch(GetNumberOfScannedHostsSinceSuccess(results));
    });
  };
}
export function GetNumberOfScannedHostsSinceSuccess(results) {
  return {
    type: constActions.SET_NUMBER_OF_SCANNED_RESULTS,
    results
  };
}

export function exportScansErrorReport() {
  return function (dispatch) {
    return Api.exportScansErrorReport().catch(error => {
      throw error;
    });
  };
}

export function getScannerStatus() {
  return function (dispatch) {
    return Api.GetScannerStatus()
      .then(result => {
        dispatch(GetScannerStatusSuccess(result.is_scan_active));
      })
      .catch(error => {
        throw error;
      });
  };
}
export function GetScannerStatusSuccess(result) {
  return {
    type: constActions.GET_SCANNER_STATUS,
    result
  };
}
export function AutoScannerExportToExcel() {
  return function (dispatch) {
    return Api.autoScanExportToExcel().catch(err => {
      throw err;
    });
  };
}
export function AutoScanExportUnScannedEndpoints() {
  return function (dispatch) {
    return Api.autoScanExportUnScannedEndpoints().catch(err => {
      throw err;
    });
  };
}

export function ChangeAutoRefreshState(isAutoRefresh) {
  return function (dispatch) {
    dispatch(dispatchAutoRefersh(isAutoRefresh));
  };
}

export function dispatchAutoRefersh(isAutoRefresh) {
  return {
    type: constActions.AUTO_REFERSH_SCANNER,
    isAutoRefresh
  };
}

export function GetHostConnectivityReportByScanId(scanId) {
  return function (dispatch) {
    return Api.GetHostConnectivityReportByScanId(scanId);
  };
}

/* actions panel related */
//selected rows
export function onSelectRow(item) {
  return function (dispatch, getState) {
    let state = getState().scannerPage;
    let rows = Object.assign([], state.selectedRows);

    let i = -1;
    rows.map(function (data, index) {
      if (data.GeneratedId == item.GeneratedId) i = index;
    });
    if (i > -1) rows.splice(i, 1);
    else {
      rows.push(item);
    }
    dispatch(dispatchSelectedRowsSuccess(rows));
  };
}

export function onSelectAll() {
  return function (dispatch, getState) {
    let state = getState().scannerPage;
    let isSelectAllChecked = !state.isSelectAllChecked;
    let rows = isSelectAllChecked ? Object.assign([], state.results) : [];
    dispatch(dispatchAllSelectedRowsSuccess(rows, isSelectAllChecked));
  };
}

export function dispatchSelectedRows(selectedRows, isSelectAllSelected) {
  return function (dispatch) {
    dispatch(dispatchAllSelectedRowsSuccess(selectedRows, isSelectAllSelected));
  };
}

export function dispatchSelectedRowsSuccess(selectedRows) {
  return {
    type: constActions.DISPATH_SCANNER_SELECTED_ROWS,
    selectedRows
  };
}

export function dispatchAllSelectedRowsSuccess(selectedRows, isSelectAllChecked) {
  return {
    type: constActions.DISPATH_SCANNER_ALL_SELECTED_ROWS,
    selectedRows,
    isSelectAllChecked
  };
}

//approved rows
export function dispatchApprovedRows(approvedRows, isAllApproved) {
  return dispatch => {
    dispatch({
      type: constActions.DISPATCH_SCANNER_APPROVED_ROWS,
      approvedRows,
      isAllApproved
    });
  };
}

export function dispatchScannerSelectedActionData(selectedScannerActionData) {
  return function (dispatch) {
    dispatch({
      type: constActions.DISPATCH_SCANNER_SELECTED_ACTION_ROW,
      selectedScannerActionData
    });
  };
}

//api actions
export function restartScansByScanProgressIds(scanProgressIds) {
  return function (dispatch) {
    return Api.restartScansByScanProgressIds(scanProgressIds);
  };
}

export function stopScansByScanProgressIds(scanProgressIds) {
  return function (dispatch) {
    return Api.stopScansByScanProgressIds(scanProgressIds);
  };
}

export function removeScannerByScanProgressIds(scanProgressIds) {
  return function (dispatch) {
    return Api.removeScannerByScanProgressIds(scanProgressIds);
  };
}

export function uninstall(scanProgressIds) {
  return function (dispatch) {
    return Api.uninstall(scanProgressIds);
  };
}

export function enableReinstall(uninstalledIds) {
  return function (dispatch) {
    return Api.enableReinstall(uninstalledIds);
  };
}

export function isSiteCreatedAutoDeploy(clientId) {
  return function (dispatch) {
    return Api.isSiteCreatedAutoDeployAsync(clientId)
      .then(res => {
        return res;
      })
      .catch(err => {
        throw err;
      });
  };
}
export function generateEPSByGroupName(osType, groupName, clientId, isGlobalAutoDeploy) {
  return function (dispatch, getState) {
    let requestDTO = {
      groupName,
      osType,
      clientId
    };

    if (isGlobalAutoDeploy) {
      return Api.generateEPSByGroupNameGlobal(requestDTO).catch(error => {
        throw error;
      });
    } else {
      return Api.generateEPSByGroupName(requestDTO).catch(error => {
        throw error;
      });
    }
  };
}

const getCurrentClientId = masterSlave => {
  let clientSiteId = -1;
  let masterSlaveObj = masterSlave;
  let slaveList =
    masterSlaveObj && masterSlaveObj.masterSlave?.SlaveDetails ? masterSlaveObj.masterSlave.SlaveDetails : [];
  if (slaveList.length > 0) {
    let currentSite = isNewBackend
      ? slaveList.find(x => x.DbTenantId === masterSlaveObj.masterSlave.CurrentSiteGuid)
      : slaveList.find(x => x.Name === masterSlaveObj.masterSlave.CurrentyLoggedClient);
    if (currentSite) {
      clientSiteId = currentSite.ClientId;
    }
  }

  return clientSiteId;
};

export function generateEPS(osType, groupName = '') {
  return function (dispatch, getState) {
    const { masterSlave, user } = getState();
    let clientId = getCurrentClientId(masterSlave);

    if (user.loggedUser.isGlobalMode) {
      return dispatch(isSiteCreatedAutoDeploy(clientId))
        .then(isGlobalAutoDeploy => {
          return dispatch(generateEPSByGroupName(osType, groupName, clientId, isGlobalAutoDeploy)).catch(err => {
            throw err;
          });
        })
        .catch(err => {
          throw err;
        });
    } else {
      return dispatch(generateEPSByGroupName(osType, groupName, clientId, false)).catch(err => {
        throw err;
      });
    }
  };
}

/* actions panel related */
